module.exports = __webpack_public_path__ + "img/IM.74192599.svg";